import { GetterTree } from "vuex";
import { RootState } from "../types";
import { UserProfile } from "./types";
export const getters: GetterTree<UserProfile, RootState> = {};
